var documentInit;

(function ($) {

	documentInit = function () {
		new Document();
	}

	class Document {
		constructor() {
			this.init();
			this.bind();
		}

		init() {
			this.$body = $(document.body);

			document.headerHeightScrolled = 100;
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
		}

		scroll() {

			var scroll = window.scrollY;

			if (scroll > 0 && !this.$body.hasClass('is-scrolled')) {
				this.$body.addClass('is-scrolled');
				return;
			}

			if (scroll == 0 && this.$body.hasClass('is-scrolled')) {
				this.$body.removeClass('is-scrolled');
				return;
			}

		}

	}

})(jQuery);

export default documentInit;